export default "<div [hidden]=\"!selected\">\n    <ng-content></ng-content>\n</div>\n";